import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
	Cart,
	CheckRound,
	File,
	Register,
	StakingRounded,
} from "../../../assets/ThemeIcon";
import Close from "../../../components/icons/Close";

import Countdown from "react-countdown";
const ProjectPopup = ({
	popup,
	setPopup,
	modal_data,
	secondPopup,
	setSecondPopup,
}) => {
	const { icon, name } = modal_data;
	const handleModal = () => {
		setPopup(false);
		setSecondPopup(true);
	};
	return (
		<Modal
			show={popup}
			size="xl"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Body className="__project-popup">
				<div className="modal-close" onClick={() => setPopup(!popup)}>
					<Close />
				</div>
				<div className="__project-popup-author mb-4">
					<img src={icon} alt="" />
					<h6>{name}</h6>
					<button className="btn">opt-in</button>
					<span>(opt-in only one time)</span>
				</div>
				<div className="d-flex flex-wrap justify-content-between">
					<div className="sale-in-progress">
						<div className="subtext">Round</div>
						<h4 className="text">Sale in Progress</h4>
						<div className="subtext mt-3">Goal Amount</div>
						<h4 className="text">1000</h4>
						<div className="subtext">Algo</div>
					</div>
					<div className="sale-in-progress">
						<div className="subtext ">Price</div>
						<h4 className="text">2 $PETS = 1 Algos</h4>
						<div className="subtext mt-3">Time Left</div>
						<h4 className="text">
							<CountdownWrapper />
						</h4>
					</div>
				</div>
				<div
					className="progress-item mt-2"
					style={{ marginBottom: "20px" }}
				>
					<div className="d-flex justify-content-between mb-2">
						<span>Start</span>
						<span>End</span>
					</div>
					<div className="__progress">
						<div
							className="proress--width"
							style={{ width: "20%" }}
						></div>
					</div>
					<div className="d-flex justify-content-between mt-2">
						<span>3.00%</span>
						<span>30/1000Algos</span>
					</div>
				</div>
				<div className="d-flex flex-wrap justify-content-between mb-4">
					<h5 className="participation-title">
						Participation Staking Tiers
					</h5>
					<button className="btn btn--secondary px-4">opt in asset</button>
				</div>
				<div className="d-flex flex-wrap-reverse justify-content-between align-items-center __gap-3 mb-4 pb-1">
					<div className="tiers">
						<Tier tiername="Tier - 1" isTier={true} />
						<Tier tiername="Tier - 2" isTier={true} />
						<Tier tiername="Tier - 3" />
						<Tier tiername="Tier - 4" />
						<Tier tiername="Tier - 5" />
					</div>
					<button
						className="btn btn-base participate-btn"
						onClick={handleModal}
					>
						participate
					</button>
				</div>
				<div className="d-flex justify-content-between align-items-start align-items-sm-end __gap-3 mb-40">
					<button
						className="btn btn-base change-tier-btn"
						style={{ marginBottom: "11px" }}
					>
						Check Tier
					</button>
					<div className="text-end">
						<div className="text-BBBBBB">Total raised</div>
						<h4 className="change-tier">30</h4>
					</div>
				</div>
				<div className="staking-steps">
					<div className="staking-steps-item">
						<div className="icon">
							<Register />
						</div>
						<div className="subtitle">Registration Opens</div>
						<div className="date">Nov 2nd, 2021 20:30</div>
					</div>
					<div className="staking-steps-item">
						<div className="icon">
							<Register />
						</div>
						<div className="subtitle">Registration Closes</div>
						<div className="date">Nov 2nd, 2021 20:30</div>
					</div>
					<div className="staking-steps-item">
						<div className="icon">
							<File />
						</div>
						<div className="subtitle">Validator Round</div>
						<div className="date">Nov 2nd, 2021 20:30</div>
					</div>
					<div className="staking-steps-item">
						<div className="icon">
							<StakingRounded />
						</div>
						<div className="subtitle">Staking Round</div>
						<div className="date">Nov 2nd, 2021 20:30</div>
					</div>
					<div className="staking-steps-item">
						<div className="icon">
							<Cart />
						</div>
						<div className="subtitle">Public Round</div>
						<div className="date">Nov 2nd, 2021 20:30</div>
					</div>
					<div className="staking-steps-item">
						<div className="icon">
							<CheckRound />
						</div>
						<div className="subtitle">Sale Ends</div>
						<div className="date">Nov 2nd, 2021 20:30</div>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};
const Tier = ({ tiername, isTier }) => {
	const [active, setActive] = useState(isTier);
	return (
		<button
			className={`btn ${active ? "active" : ""}`}
			onClick={() => setActive(!active)}
		>
			{tiername}
		</button>
	);
};

const renderer = ({ days, hours, minutes, seconds, completed, className }) => {
	if (completed) {
		return <h2>Hungry Hamster NFT Officially Launched</h2>;
	} else {
		return (
			<span className={`countdown ${className}`}>
				<span className="subtitle">{days < 10 ? `0${days}` : days}d :</span>
				<span className="subtitle">
					{hours < 10 ? `0${hours}` : hours}h :
				</span>
				<span className="subtitle">
					{minutes < 10 ? `0${minutes}` : minutes}m :
				</span>
				<span className="subtitle">
					{seconds < 10 ? `0${seconds}` : seconds}s
				</span>
			</span>
		);
	}
};

const CountdownWrapper = ({ className }) => {
	const convertDate = (date, tzString) => {
		return new Date(
			(typeof date === "string" ? new Date(date) : date).toLocaleString(
				"en-US",
				{ timeZone: tzString }
			)
		);
	};
	return (
		<>
			<Countdown
				date={convertDate("February 14, 2023 00:00:00", "Asia/singapore")}
				renderer={renderer}
				className={className}
			/>
		</>
	);
};

export default ProjectPopup;
